(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initSlider(root) {
    var frame = root.querySelector('[data-before-after-frame]');
    var afterLayer = root.querySelector('[data-before-after-layer="after"]');
    var handle = root.querySelector('[data-before-after-handle]');
    var rocket = root.querySelector('[data-before-after-rocket]');
    if (!frame || !afterLayer || !handle) return;

    function setPercent(percent) {
      percent = clamp(percent, 0, 100);
      afterLayer.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
    }

    function percentFromClientX(clientX) {
      var rect = frame.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function moveRocket(clientX, clientY) {
      if (!rocket) return;
      var rect = frame.getBoundingClientRect();
      var x = clientX - rect.left;
      var y = clientY - rect.top;
      rocket.style.transform = 'translate3d(' + (x - 24) + 'px, ' + (y - 24) + 'px, 0) rotate(45deg)';
    }

    frame.addEventListener('mouseenter', function (e) {
      frame.classList.add('before-after__frame--rocket-active');
      if (rocket) {
        rocket.classList.add('is-visible');
        moveRocket(e.clientX, e.clientY);
      }
    });
    frame.addEventListener('mousemove', function (e) {
      setPercent(percentFromClientX(e.clientX));
      moveRocket(e.clientX, e.clientY);
    });
    frame.addEventListener('mouseleave', function () {
      setPercent(0);
      frame.classList.remove('before-after__frame--rocket-active');
      if (rocket) rocket.classList.remove('is-visible');
    });
    frame.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        frame.classList.add('before-after__frame--rocket-active');
        if (rocket) {
          rocket.classList.add('is-visible');
          moveRocket(e.touches[0].clientX, e.touches[0].clientY);
        }
        setPercent(percentFromClientX(e.touches[0].clientX));
      },
      { passive: true }
    );
    frame.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        // Prevent the browser from treating this horizontal drag as a
        // swipe-to-go-back / page-scroll gesture while inside the frame.
        e.preventDefault();
        setPercent(percentFromClientX(e.touches[0].clientX));
        moveRocket(e.touches[0].clientX, e.touches[0].clientY);
      },
      { passive: false }
    );
    frame.addEventListener('touchend', function () {
      setPercent(0);
      frame.classList.remove('before-after__frame--rocket-active');
      if (rocket) rocket.classList.remove('is-visible');
    });

    setPercent(0);
  }

  document.querySelectorAll('[data-before-after]').forEach(initSlider);
})();
